import React from "react";
import { createAuthRepository, createEventsRepository, createUserRepository, createConfigurationRepository } from "../../repositories";
import { createAuthService } from "../../services/AuthService/Auth.service";
import { createUserService } from "../../services/UserService/User.service";
import { createEventsService } from "../../services/EventsService/Events.service";
import { createConfigurationService } from "../../services/ConfigurationService/Configuration.service";

export const ServicesContext = React.createContext(undefined);

export const ServicesProvider = ({ children }) => {
  const authRepository = createAuthRepository();
  const authService = createAuthService(authRepository);

  const userRepository = createUserRepository();
  const userService = createUserService(userRepository);

  const eventsRepository = createEventsRepository();
  const eventsService = createEventsService(eventsRepository);

  const configurationRepository = createConfigurationRepository();
  const configurationService = createConfigurationService(configurationRepository);

  return (
    <ServicesContext.Provider
      value={{
        authService,
        userService,
        eventsService,
        configurationService,
      }}
    >
      {children}
    </ServicesContext.Provider>
  );
};
